<template lang="pug">
.shopping-cart-row
    .loader.skeleton(v-if="loading || !(item.article && item.article.product)")
        .image-placeholder
        .lines
            .line(v-for="i in 3" :class="'line-' + i")
    .error(v-else-if="error") {{ error }}
    .shopping-cart-item(v-else)
        img(v-if="image && image.source" :src="image.source.url" :height="image.height" :width="image.width")
        .image-placeholder(v-else)
        .details
            .flex-row
                h3.name
                    span {{ item.article.name || item.article.product.name }}
                    small {{ item.article.product.nr }} / {{ item.article.sku }}
                .grow
                //- .price.flex-row(v-if="qty > 1 || item.sale_price")
                //-     .regular-price.text-gray(:class="{ 'strike-through': item.sale_price }") {{ item.price | moneyFormat(currency.code) }}
                //-     .sale-price(v-if="qty > 1 && item.sale_price") {{ item.sale_price | moneyFormat(currency.code) }}
                .price.flex-row(:style="{ '--suffix-width': 'calc(' + currency.sign.length + 'ch + 6px)' }")
                    .regular-price.text-gray(v-if="item.sale_price != null" :class="{ 'strike-through': item.sale_price }")
                        | {{ item.price | moneyFormat(currency.code) }}
                    el-input(
                        v-model="salePrice"
                        size="mini"
                        type="number"
                        min="0.01"
                        step="0.01"
                        :placeholder="item.price"
                        :style="{ '--input-min-width': 'calc(' + (item.price.toString().length + currency.sign.length) + 'ch + 1.2rem)', '--input-width': 'calc(' + ((item.sale_price ? item.sale_price.toString().length : 0) + currency.sign.length) + 'ch + 1.2rem)' }"
                    )
                        template(slot="suffix") {{ currency.sign }}
                .qty.flex-row.gap-sm
                    el-button.delete(
                        v-if="qty <= 1"
                        circle
                        size="mini"
                        type="danger"
                        icon="el-icon-fa-trash-alt fas"
                        @click.stop.prevent="$emit('delete', item)"
                    )
                    el-button.decrease(
                        v-else
                        circle
                        size="mini"
                        type="info"
                        icon="el-icon-fa-minus fas"
                        :disabled="qty <= 1"
                        :plain="qty <= 1"
                        @click.stop.prevent="decreaseQty"
                    )
                    el-input(
                        v-if="qty"
                        v-model="qty"
                        size="mini"
                        type="number"
                        min="1"
                        step="1"
                        :style="{ '--input-width': 'calc(' + qty.toString().length + 'ch + 2rem)' }"
                    )
                    el-button.increase(
                        circle
                        size="mini"
                        type="info"
                        icon="el-icon-fa-plus fas"
                        @click.stop.prevent="increaseQty"
                    )
                //- h3.price
                //-     span.regular-price(:class="{ 'strike-through': item.sale_price }") {{ qty * item.price | moneyFormat(currency.code) }}
                //-     .sale-price(v-if="item.sale_price") {{ qty * item.sale_price | moneyFormat(currency.code) }}
                h3.sale-price(v-if="item.sale_price") {{ qty * item.sale_price | moneyFormat(currency.code) }}
                h3.regular-price(v-else :class="{ 'strike-through': item.sale_price }") {{ qty * item.price | moneyFormat(currency.code) }}
                //- el-button.delete(
                //-     circle
                //-     size="mini"
                //-     type="danger"
                //-     icon="el-icon-fa-trash-alt fas"
                //-     @click.stop.prevent="$emit('delete', item)"
                //- )
            .bottom-row.flex-row
                .properties.flex-row.grow
                    template(v-if="selectablePropertyPivots.length")
                        .property(v-for="pivot in selectablePropertyPivots")
                            span.label {{ pivot.property.name }}
                            b : {{ getSelectedValue(pivot) }}
                    template(v-if="inputPropertyPivots.length")
                        .property(v-for="pivot in inputPropertyPivots")
                            span.label {{ pivot.property.name }}
                            b :&nbsp;
                            b(v-if="getUserInput(pivot)") {{ getUserInput(pivot) }}
                            span.gray(v-else) {{ $t('Undefined') }}
                .stock-info(v-if="item.article.product.manage_stock")
                    .out-of-stock(v-if="item.article.sellable_qty_sum <= 0")
                        | {{ $t('Out of stock') }}
                        i.el-icon-fa-exclamation-triangle.fas
                    .in-stock(v-else v-html="$t('In stock: <b>{qty}</b>', { qty: item.article.sellable_qty_sum })")
</template>

<i18n>
{
    "en": {
        "In stock: <b>{qty}</b>": "In stock: <b>{qty}</b>"
    },
    "de": {
        "Undefined": "Nicht definiert",
        "In stock: <b>{qty}</b>": "Auf Lager: <b>{qty}</b>",
        "Out of stock": "Nicht auf Lager"
    }
}
</i18n>

<script>
import ArticleApi from '@/extensions/shop/store/api/article';
import { useSetupStore } from '@/stores';
import pinia from '@/pinia';

export default {
    name: 'ShoppingCartItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        customer: {
            type: Object,
            required: false
        },
        priceType: {
            type: String,
            required: true
        },
        currency: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            error: false,
        }
    },
    computed: {
        setupStore() {
            return useSetupStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        customerGroup() {
            return this.customer.customerGroup
                || this.activeCms.shop.defaultCustomerGroup
        },
        selectablePropertyPivots() {
            const product = _.get(this.item, 'article.product')
            if (!product) return []

            return product.propertyPivots.filter(el => el.valueOptions.length > 1 || el.property.article_required)
        },
        inputPropertyPivots() {
            const product = _.get(this.item, 'article.product')
            if (!product) return []

            return product.propertyPivots.filter(el => el.property.propType.key === 'input')
        },
        image() {
            let media = _.get(this.item, 'article.media') || []
            let el = media.find(el => el.type === 'image' && el.list)
                || media.find(el => el.type === 'image')

            if (el && el.image) return el.image

            media = _.get(this.item, 'article.product.media') || []
            el = media.find(el => el.type === 'image' && el.list)
                || media.find(el => el.type === 'image')

            if (el && el.image) return el.image
        },
        qty: {
            get() {
                return this.item.qty
            },
            set(value) {
                if (value > 0) this.item.qty = parseInt(value)
                else this.item.qty = 1
            }
        },
        salePrice: {
            get() {
                return this.item.sale_price
            },
            set(value) {
                this.item.sale_price = value ? parseFloat(value) : null
            }
        }
    },
    methods: {
        getSelectedValue(pivot) {
            const valueOptions = pivot.valueOptions
            const selectedIDs = this.item.propertyValueOptions.map(el => parseInt(el.id))

            const valueOption = valueOptions.find(el => selectedIDs.includes(parseInt(el.id)))

            const value = _.get(valueOption, pivot.property.propType.value_field)
            const valueAlt = _.get(valueOption, pivot.property.propType.value_field_alt);

            return value
        },
        getUserInput(pivot) {
            const property = this.item.properties.find(el => el.id == pivot.property.id)
            return _.get(property, 'value.text')
        },
        increaseQty() {
            this.item.qty++
        },
        decreaseQty() {
            if (this.item.qty > 1) this.item.qty--
        }
    },
    mounted() {
        if (!this.item.article.sku) {
            const variables = {
                id: this.item.article.id,
            }

            if (this.customer) {
                variables.mimicCustomer = {
                    id: this.customer.id,
                    customerGroup: this.customerGroup,
                }
            }

            this.loading = true

            ArticleApi.findArticle(variables)
                .then(article => {
                    this.item.article = article
                })
                .catch(error => {
                    this.error = error
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="sass" scoped>
.skeleton,
.shopping-cart-item
    display: flex
    gap: 0.5rem
    padding: 0.8rem
    background: $color-skeleton
    border-radius: 4px

.lines
    flex-grow: 1
    display: flex
    flex-direction: column
    gap: 0.5rem
.line
    width: 100%
    height: 14px
    background: lighten($color-grey-text, 20%)
    border-radius: 40px
    &.line-1
        width: 30%
        height: 21px
    &.line-2
        width: 80%
    &.line-3
        width: 40%

.text-gray
    font-weight: 400 !important
    color: $color-grey-text

.gap-sm
    gap: 4px

.image-placeholder
    height: 65px
    aspect-ratio: 3/4
    background: lighten($color-grey-text, 20%)
    border-radius: 4px

.shopping-cart-item
    img
        height: 65px
        width: auto
        border-radius: 4px
        background: lighten($color-grey-text, 20%)
    h3
        margin-top: 0
        margin-bottom: 0
    h3.name
        line-height: 1
        span
            display: block
        small
            font-size: 0.8rem
            font-weight: 400
    .details
        flex-grow: 1
        .flex-row
            align-items: center
    .el-input::v-deep
        .el-input__inner
            width: var(--input-width)
            min-width: var(--input-min-width, 2rem)
            // min-width: 2rem
            padding-left: 4px
            padding-right: 4px
            font-size: 0.8rem
            &[type="number"]
                font-family: monospace
                text-align: right
                padding-right: var(--suffix-width)
                -moz-appearance: textfield
                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button
                    -webkit-appearance: none
                    margin: 0
        .el-input__suffix
            display: flex
            align-items: center
            justify-content: center
    .qty .el-input::v-deep
        .el-input__inner
            font-weight: 600
            font-size: 0.8rem
            text-align: center
            padding-left: 0
            padding-right: 0

.el-input::v-deep .el-input__suffix *
    pointer-events: none

.bottom-row
    margin-top: 0.5rem

.properties
    .label
        font-style: italic
    .gray
        font-style: italic
        color: lighten($color-grey-text, 5%)

.regular-price,
.sale-price
    font-size: 1rem

.sale-price
    color: $--color-danger
    font-weight: bold

.stock-info .out-of-stock i
    color: $--color-danger
    margin-left: 0.5rem
    // margin-right: 6px

.strike-through
    position: relative
    font-weight: 400
    &:before
        position: absolute
        content: ""
        left: -3px
        top: 50%
        right: -3px
        border-top: 1px solid rgba(0,0,0,0.6)
        // border-color: $--color-info
        transform: rotate(-5deg)
</style>
